var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.fields),function(field){return _c('field',{key:field.attribute,attrs:{"field":field,"model":_vm.model,"errors":_vm.errors,"event-bus":_vm.$events,"layout":_vm.layout}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }